import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useClaimApartment } from "@/api/tenant/mutations";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { setDrfErrors } from "@/utils/errors";

type ClaimFormValues = { key: string };

export function ClaimApartmentForm() {
	const { t } = useTranslation();
	const { mutate, isPending } = useClaimApartment();
	const {
		register,
		handleSubmit,
		setError,
		formState: { errors },
	} = useForm<ClaimFormValues>();

	const onSubmit = (data: ClaimFormValues) => {
		mutate(data, {
			onError: (err) => {
				setDrfErrors(err, setError);
				toast.error(t("tenant.claim.errorGeneric"));
			},
		});
	};

	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex flex-col gap-4"
			noValidate
		>
			<div className="flex flex-col gap-1.5">
				<Label htmlFor="claim-key">{t("tenant.claim.keyLabel")}</Label>
				<Input
					id="claim-key"
					placeholder={t("tenant.claim.keyPlaceholder")}
					autoComplete="off"
					spellCheck={false}
					{...register("key", {
						required: t("tenant.claim.keyRequired"),
					})}
					aria-describedby={errors.key ? "claim-key-error" : undefined}
					aria-invalid={!!errors.key}
				/>
				{errors.key && (
					<p
						id="claim-key-error"
						className="text-destructive text-sm"
						role="alert"
					>
						{errors.key.message}
					</p>
				)}
			</div>
			<Button type="submit" disabled={isPending}>
				{isPending ? t("tenant.claim.submitting") : t("tenant.claim.submit")}
			</Button>
		</form>
	);
}
